import './App.css';
import ReactDOM from 'react-dom/client'; //React 18 import different than previous project
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Form from './Form';
import FormSubmit from './FormSubmit';
import QRCode from './QRCode';
import COEForm from './COEForm';
import COEFormLanguage from './COEFormLanguage';
import COEAdmin from './COEAdmin';
import CaseDismissedForm from './CaseDismissedForm';
import CaseDismissedAdmin from './CaseDismissedAdmin';
import VPNDigitalForm from './VPNDigitalForm';
import MedicalTravellerForm from './MedicalTravellerForm';
import MedicalTravellerFormLanguage from './MedicalTravellerFormLanguage';
import MedicalTravellerAdmin from './MedicalTravellerAdmin';



function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<Form />} />
                <Route path="/qrcode" element={<QRCode />} />
                <Route path="/COEAdmin" element={<COEAdmin />} />
                <Route path="/CaseDismissedAdmin" element={<CaseDismissedAdmin />} />
                <Route path="/MedicalTravellerAdmin" element={<MedicalTravellerAdmin />} />
                <Route path="/formSubmit" element={<FormSubmit />} />
                <Route path="/:uniqueLink" element={<Form />} />
                <Route path="/f/bnVyc2luZy9DT0VGb3Jt" element={<COEForm />} />
                <Route path="/f/bnVyc2luZy9DT0VGb3JtL2xhbmd1YWdl" element={<COEFormLanguage />} />
                <Route path="/f/Q2FzZURpc21pc3NlZEZvcm0=" element={<CaseDismissedForm />} />
                <Route path="/VPNRequest/VPNDigitalForm" element={<VPNDigitalForm />} />
                <Route path="/f/TWVkaWNhbFRyYXZlbGxlckZvcm0=" element={<MedicalTravellerForm />} />
                <Route path="/f/TWVkaWNhbFRyYXZlbGxlckZvcm0vbGFuZ3VhZ2U=" element={<MedicalTravellerFormLanguage />} />
            </Routes>
        </Router>
    );
}

export default App;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

